import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { effect, Injectable } from '@angular/core';
import { FilterBuilder } from '../../../../../modules/content/helper/filter.builder';
import { routeParams } from '../../../../../modules/shared/shared.global-service';
import { ePrescriptionWithMedicationsFrag } from '../../../../../services/types/e-prescription.gql-types';

@Injectable()
export class FolderEPrescriptionsListStore extends ComponentStoreV2Factory {

    constructor() {
        super();
        effect(() => {
            this.refreshData();
        });
    }

    public async refreshData(): Promise<void> {
        await this.api.getEPrescriptions(FilterBuilder.filter({
            folderId: routeParams.folderId(),
            sort: { column: 'issuedAt', direction: 'DESC' },
        }), ePrescriptionWithMedicationsFrag);
    }

}
